// extracted by mini-css-extract-plugin
module.exports = {"label":"Select_label__3wfk9","selectIcon":"Select_selectIcon__adwyO"};